import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { REGEX_EMAIL_VALIDATION } from '../common/constants'
import { Spinner } from '../components'
import { useAuthContext } from '../contexts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

export function LoginPage() {
  const navigate = useNavigate()
  const { authInProgress, isAuthorized, error, signIn } = useAuthContext()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [enabled, setEnabled] = useState(false)
  const showOptions = false

  useEffect(() => {
    setEnabled(REGEX_EMAIL_VALIDATION.test(email) && password !== '')
  }, [email, password])

  useEffect(() => {
    if (isAuthorized) {
      navigate('/')
    }
  }, [isAuthorized]) // eslint-disable-line react-hooks/exhaustive-deps

  async function onClickSignIn() {
    await signIn(email, password)
  }

  return (
    <div className={tailwind.container}>
      {error ? <div className={tailwind.alert}>{error}</div> : <div className={tailwind.noAlert}></div>}
      <div className="w-full max-w-xs mx-auto">
        <form>
          <div className="mb-3">
            <label className={tailwind.label}>Email</label>
            <input
              className={tailwind.inputText}
              id="email"
              type="text"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className={tailwind.label}>Password</label>
            <div className="flex flex-row">
              <div className="flex justify-between">
                <input
                  className={tailwind.inputText}
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="******************"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="p-2" onClick={() => setShowPassword(!showPassword)}>
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} className="text-gray-400" />
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <button
              className={
                authInProgress
                  ? tailwind.buttonAuthInProgress
                  : enabled
                  ? tailwind.buttonEnabled
                  : tailwind.buttonDisabled
              }
              type="button"
              onClick={onClickSignIn}
              disabled={!enabled || authInProgress}
            >
              Sign in
            </button>
            {authInProgress ? (
              <div className={tailwind.spinner}>
                <Spinner size={25} color={'blue'} />
              </div>
            ) : (
              ''
            )}
          </div>
          {showOptions ? (
            <div className="flex items-center justify-between mt-4">
              <Link className={tailwind.link} to="/create-account">
                Create Account
              </Link>
              <Link className={tailwind.link} to="/forgot-password">
                Forgot Password?
              </Link>
            </div>
          ) : null}
        </form>
      </div>
    </div>
  )
}

const tailwind = {
  container: 'mt-3',
  form: 'bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4',
  label: 'block text-gray-700 text-sm font-bold mb-2',
  inputText:
    'appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none w-80',
  buttonEnabled:
    'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline',
  buttonAuthInProgress: 'bg-blue-300 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline',
  buttonDisabled: 'bg-gray-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline',
  link: 'inline-block align-baseline font-bold text-blue-500 hover:text-blue-800 no-underline',
  noAlert: 'text-white font-bold rounded-t px-4 py-2 mb-10 mt-6 h-10',
  alert: 'bg-red-500 text-white font-bold rounded px-4 py-2 mb-10 mt-6 h-10 w-[320px] mx-auto text-center',
  spinner: 'pl-4',
}
